<template>
  <div>
    <h3>Pending <span class="fw-semi-bold">Checkup Prescriptions</span></h3>
    <p>
      Pending prescriptions for patients' checkups
    </p>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>Patient</th>
          <th>Start Time</th>
          <th>Action(s)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(pendingPrescription, index) in pendingPrescriptions" :key="pendingPrescription.id">
          <td>{{ index + 1 }}</td>
          <td>{{ pendingPrescription.patientcheckup.patient.name }}</td>
          <td>{{ pendingPrescription.patientcheckup.start_time }}</td>
          <td>
            <b-button variant="outline-info" size="xs"
                      @click="checkupPrescriptionForm.checkupprescription_id = pendingPrescription.id; showPrescriptionCreateModal = true">
              create
            </b-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>


    <!--    Prescription create modal-->
    <b-modal id="modal-center" v-model="showPrescriptionCreateModal" size="xl" centered title="Create Prescription">
      <b-form>

        <b-form-textarea v-model="checkupPrescriptionForm.contents.disease_description" class="col-10" type="text"
                         placeholder="Write patient problem description"/>

        <div class="mt-4">
          <div v-for="(medicineDescription, index) in checkupPrescriptionForm.contents.medicine_descriptions"
               :key="index">
            <div class="row m-1">
              <b-form-input v-model="medicineDescription.name" class="col-8" type="text" placeholder="medicine name"/>
              <b-form-input v-model="medicineDescription.duration" class="col-3" type="text" placeholder="duration"/>
              <b-button v-if="index === checkupPrescriptionForm.contents.medicine_descriptions.length-1"
                        variant="outline-success" size="xs" class="col-1 fa fa-plus"
                        @click="checkupPrescriptionForm.contents.medicine_descriptions.push({name: '', tags: [], duration: ''})">

              </b-button>
              <b-button v-else variant="outline-danger" size="xs" class="col-1 fa fa-minus"
                        @click="checkupPrescriptionForm.contents.medicine_descriptions.splice(index, 1)">
              </b-button>
            </div>
            <div class="row m-1">
              <b-form-group>
                <b-form-checkbox-group
                    v-model="medicineDescription.tags"
                    :options="dosageOptions"
                    switches
                    style="outline: 0"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div v-for="(testDescription, index) in checkupPrescriptionForm.contents.test_descriptions" :key="index">
            <div class="row m-1">
              <b-form-input v-model="testDescription.name" class="col-10" type="text" placeholder="test name"/>
              <b-button v-if="index === checkupPrescriptionForm.contents.test_descriptions.length-1"
                        variant="outline-success"
                        size="xs" class="col-1 fa fa-plus"
                        @click="checkupPrescriptionForm.contents.test_descriptions.push({name: ''})">
              </b-button>
              <b-button v-else variant="outline-danger" size="xs" class="col-1 fa fa-minus"
                        @click="checkupPrescriptionForm.contents.test_descriptions.splice(index, 1)">
              </b-button>
            </div>

          </div>
        </div>


        <b-form-textarea v-model="checkupPrescriptionForm.contents.special_note" class="col-10" type="text"
                         placeholder="Write Note/Instruction"/>
      </b-form>

      <template v-slot:modal-footer>
        <b-button size="sm" variant="success" @click="createCheckupPrescription">
          Confirm
        </b-button>
        <b-button size="sm" variant="danger" @click="showPrescriptionCreateModal = false">
          Cancel
        </b-button>

      </template>
    </b-modal>

    <!--    Presentation create modal end-->
  </div>
</template>

<script>
import {Form} from "vform";

import PrescriptionService from '@/services/doctor/prescription.service'

export default {
  name: "PendingPrescriptions",
  props: ['doctor'],
  data() {
    return {
      showPrescriptionCreateModal: false,
      pendingPrescriptions: [],
      dosageOptions: [
        {text: 'morning', value: 'morning'},
        {text: 'noon', value: 'noon'},
        {text: 'night', value: 'night'},
        {text: 'every 6hrs', value: 'every 6hrs '},
        {text: 'every 12hrs', value: 'every 12hrs'},
        {text: 'every 24hrs', value: 'every 24hrs'}
      ],
      checkupPrescriptionForm: new Form({
        checkupprescription_id: '',
        contents: {
          disease_description: '',
          medicine_descriptions: [{
            name: '',
            tags: [],
            duration: ''
          }],
          test_descriptions: [{
            name: '',
          }],
          special_note: ''
        }
      }),
    }
  },
  watch: {
    checkupPrescriptionForm: (v) => console.log(v)
  },
  methods: {
    fetchPendingCheckupPrescriptions() {
      localStorage.removeItem('endcall');
      PrescriptionService.fetchPendingPrescriptions(this.doctor.id)
          .then((response) => {
            if (response.status === 200) {
              this.pendingPrescriptions = response.data;
            }
          })
          .catch((e) => console.log(e));
    },
    createCheckupPrescription() {

      PrescriptionService.createPrescriptionPDF(this.checkupPrescriptionForm.checkupprescription_id, {prescription: this.checkupPrescriptionForm.contents})
          .then((response) => {
            if (response.status === 200 || response.status === 204) {
              this.showPrescriptionCreateModal = false;
              this.checkupPrescriptionForm.clear();
            }
          })
          .then(() => {
            this.fetchPendingCheckupPrescriptions();
          })
          .catch((e) => console.log(e));
    }
  },
  mounted() {
    window.addEventListener('storage', (evt) => {
      if (evt.key !== 'endcall') return; // ignore other keys
      var message = JSON.parse(evt.newValue);
      if (message) {
        this.fetchPendingCheckupPrescriptions();
      }
    });


    this.fetchPendingCheckupPrescriptions();
  }
}
</script>

<style scoped>

</style>